import { Avatar as MuiAvatar } from "@mui/material";
import React from "react";

const getInitials = (name: string | undefined) => {
  if (!name) {
    return "";
  }
  const list = name.split(" ").map(word => word[0]);
  if (list.length === 1) {
    return list[0];
  }
  return `${list.at(0)}${list.at(-1)}`;
};

const AvatarsColors = {
  0: "--primary-900",
  1: "--primary-300",
  2: "--primary-100",
  3: "--secondary-900",
  4: "--secondary-300",
  5: "--secondary-100",
  6: "--primary-300",
  7: "--primary-200",
  8: "--primary-100",
  9: "--primary-50",
};

const getColor = (id: string | null) => {
  // User should have constant avatar's color.
  // id is uuid4. Get part of this number. Change from hexadecimal to decimal and translate to color
  const number = (parseInt(id?.split("-")?.at(-1) || "0", 16) % 10) as 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  return AvatarsColors[number];
};

interface AvatarProps {
  userId: string | null;
  name: string;
  sx?: any;
}

export const Avatar: React.FC<AvatarProps> = ({ userId, name, sx }) => (
  <MuiAvatar
    alt={name}
    sx={[
      {
        mr: "16px",
        background: `var(${getColor(userId)})`,
      },
      sx || {},
    ]}
  >
    {getInitials(name)}
  </MuiAvatar>
);
